module.exports = __webpack_public_path__ + "home-block-4-overlay-wide-1-N7W1G.png";